import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { DeathsAndDiseasesController } from 'src/controllers/deaths-and-diseases.controller'
import { DeathsAndDiseasesDto } from 'src/dto/deaths-and-diseases.dto'

const deathsAndDiseasesController = new DeathsAndDiseasesController()

export function useGetDeathsAndDiseasesList() {
  const { userFarm: farmId } = useAuth()
  return useQuery<DeathsAndDiseasesDto[], Error>({
    queryKey: ['getDeathsAndDiseasesList', farmId],
    queryFn: () => deathsAndDiseasesController.getDeathsAndDiseasesList(farmId!),
    enabled: !!farmId
  })
}
